import Vue from 'vue'
import Vuex from 'vuex'

/* Theme Core */
import verticalMenu from './vertical-menu'
import appConfig from './app-config'
import app from './app'
/* App Core */
import users from './Admin/Core/users'
import userTypes from './Admin/Core/user_types'
import abilities from './Admin/Core/abilities'
import cropperUploads from './Admin/Core/cropper_uploads'
import fileUpload from './Admin/Core/file_upload'
/* App Data */
import branches from './Admin/App/branches'
import carousel from './Admin/App/carousel'
import categories from './Admin/App/categories'
import configs from './Admin/App/configs'
import feedbacks from './Admin/App/feedbacks'
import feedbackNotes from './Admin/App/feedback_notes'
import notifications from './Admin/App/notifications'
import productAllergens from './Admin/App/product_allergens'
import productCalories from './Admin/App/product_calories'
import productMaterials from './Admin/App/product_materials'
import productPortions from './Admin/App/product_portions'
import productPrices from './Admin/App/product_prices'
import productTimes from './Admin/App/product_times'
import productGallery from './Admin/App/product_gallery'
import products from './Admin/App/products'
import socialMedia from './Admin/App/socialmedia'
import welcome from './Admin/App/welcome'
import qrcodes from './Admin/App/qrcodes'
import reports from './Admin/App/reports'
import userBranches from './Admin/App/user_branches'
/* App Defines */
import socialMediaNetworks from './Admin/Defines/socialmedia_networks'
import portionTypes from './Admin/Defines/portion_types'
import qrcodeColors from './Admin/Defines/qrcode_colors'
import zennoStocks from './Admin/Defines/zenno_stocks'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    abilities,
    cropperUploads,
    fileUpload,
    users,
    userTypes,
    verticalMenu,
    branches,
    carousel,
    categories,
    configs,
    feedbacks,
    feedbackNotes,
    notifications,
    productAllergens,
    productCalories,
    productMaterials,
    productPortions,
    productPrices,
    productTimes,
    productGallery,
    products,
    socialMedia,
    socialMediaNetworks,
    portionTypes,
    qrcodeColors,
    zennoStocks,
    welcome,
    qrcodes,
    reports,
    userBranches,
  },
  strict: process.env.DEV,
})
